export const rejectedSuggestions = (state = [], action) => {
    switch (action.type) {
        case "SET_REJECTED_SUGGESTIONS":
            return action.payload;
        case "DELETE_REJECTED_SUGGESTION":
            return state.filter(item => item._id !== action.payload);
        case "ADD_REJECTED_SUGGESTION":
            return [action.payload, ...state];
        case "UPDATE_REJECTED_SUGGESTION":
            return state.map(item => item._id === action.payload._id ? action.payload : item);
        default:
            return state;
    }
};
